import pointQueries from '@apis/queries/pointQueries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function usePointCards() {
    const { t } = useTranslation('point');
    const { data, status } = useQuery(pointQueries.cardList({ page: 0, size: 512 }));
    const { pop } = useFlow();
    const toast = useToast();
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('error.loadFailed'));
            pop();
        }
    }, [toast, pop, status]);
    return data?.content;
}

export default usePointCards;
